import { render } from "./Index.vue?vue&type=template&id=f548009e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=f548009e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f548009e"

export default script